/**
 * Device ID Utility
 * Generates and stores a unique device ID for single-device login
 */

/**
 * Generate a unique device ID
 * Uses browser fingerprinting + localStorage for persistence
 */
export const generateDeviceId = () => {
  // Try to get existing device ID from localStorage
  let deviceId = localStorage.getItem('deviceId');
  
  if (deviceId) {
    return deviceId;
  }
  
  // Generate new device ID using browser fingerprint
  // eslint-disable-next-line no-restricted-globals
  const screenObj = typeof screen !== 'undefined' ? screen : { width: 0, height: 0, colorDepth: 0 };
  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    screenObj.width,
    screenObj.height,
    screenObj.colorDepth,
    new Date().getTimezoneOffset(),
    navigator.platform,
    navigator.hardwareConcurrency || 0,
    navigator.deviceMemory || 0
  ].join('|');
  
  // Create a hash-like ID from fingerprint
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Add timestamp for uniqueness
  const timestamp = Date.now();
  deviceId = `device_${Math.abs(hash)}_${timestamp}`;
  
  // Store in localStorage
  localStorage.setItem('deviceId', deviceId);
  
  return deviceId;
};

/**
 * Get device ID (generate if doesn't exist)
 */
export const getDeviceId = () => {
  return generateDeviceId();
};

/**
 * Clear device ID (for logout or device change)
 */
export const clearDeviceId = () => {
  localStorage.removeItem('deviceId');
};

